import { chain, get, isNull, isUndefined } from 'lodash';

export const weightedAverageAggregatorFn = (series, dataSeries, options = {}) => {
  series.dataFields.customValue = `${dataSeries.seriesColumn}_weight`;
  series.adapter.add('groupDataItem', (val) => {
    const totalWeightedValue = chain(val.dataItem.groupDataItems)
      .reject((v) => v.valueY === undefined || v.customValue === undefined)
      .reduce((pV, cV) => pV + cV.valueY * cV.customValue, 0)
      .defaultTo(null)
      .value();

    const totalWeight = chain(val.dataItem.groupDataItems)
      .reject((v) => v.valueY === undefined || v.customValue === undefined)
      .reduce((pV, cV) => (pV || 0) + cV.customValue, null)
      .value();

    if (totalWeight === null) {
      return {
        ...val,
        value: null,
      };
    }
    if (totalWeight === 0) {
      return {
        ...val,
        value: 0,
      };
    }

    return {
      ...val,
      value: totalWeightedValue / totalWeight,
    };
  });
};

export const averageAggregatorFn = (series, dataSeries, options = {}) => {
  const rejectCheck = (val) => {
    const nullValue = isNull(val?.valueY) && isNull(val?.customValue);
    const undefinedValue = isUndefined(val?.valueY) && isUndefined(val?.customValue);

    return nullValue || undefinedValue;
  };

  series.dataFields.customValue = `${dataSeries.seriesColumn}_avg`;
  series.adapter.add('groupDataItem', (val) => {
    const validEntries = chain(val.dataItem.groupDataItems)
      .reject((v) => rejectCheck(v))
      .value();

    if (validEntries.length === 0) {
      return {
        ...val,
        value: null,
      };
    }

    const totalValue = chain(validEntries)
      .reduce((pV, cV) => pV + cV.valueY, 0)
      .value();

    const average = totalValue / validEntries.length;

    return {
      ...val,
      value: average,
    };
  });
};

export const customFrequencyFn = (series, dataSeries, options = {}) => {
  series.dataFields.customValue = `${dataSeries.seriesColumn}_div`;
  series.adapter.add('groupDataItem', (val) => {
    const occurrences = chain(val.dataItem.groupDataItems)
      // Reject phase line phantom data
      .reject((v) => v.valueY === undefined && v.customValue === undefined)
      .reduce((pV, cV) => {
        return pV + cV.valueY * cV.customValue;
      }, 0)
      .defaultTo(null)
      .value();
    let frequencyDuration = chain(val.dataItem.groupDataItems)
      // Reject phase line phantom data
      .reject((v) => v.valueY === undefined && v.customValue === undefined);
    if (dataSeries.frequencyDivisorDistinctBy) {
      // We only want to count distinct occurrences of the frequencyDivisorDistinctBy (eg. session id)
      const getFreqDivisorDistinctBy = (v) => get(v, ['dataContext', dataSeries.frequencyDivisorDistinctBy]);
      frequencyDuration = frequencyDuration.uniqBy((v) => getFreqDivisorDistinctBy(v));
    }
    frequencyDuration = frequencyDuration
      .reduce((pV, cV) => (pV || 0) + cV.customValue, null)
      .defaultTo(null)
      .value();

    if (frequencyDuration === null) {
      return {
        ...val,
        value: null,
      }; // frequencyDuration;
    }
    if (frequencyDuration === 0) {
      return {
        ...val,
        value: 0,
      }; // frequencyDuration;
    }
    return {
      ...val,
      value: occurrences / frequencyDuration,
    }; // frequencyDuration;
  });
};

export const defaultFn = (series, dataSeries) => {
  series.groupFields.valueY = dataSeries.chartAggregator || dataSeries.aggregator;
};
